import _ from 'lodash';
import moment from 'moment';
import classNames from 'classnames';

import React from 'react';
import { useDispatch } from 'react-redux';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { Paper, Box, Typography } from '@material-ui/core';
import { useAuth } from 'hooks';
import { User, Shooting } from 'models';
import { showSideBar } from 'state/actions';
import { SIDEBAR } from 'config/constants';

const useStyles = makeStyles({
  shootingListItem: {
    padding: 15,
    boxSizing: 'border-box',
    cursor: 'pointer',
  },
  date: {
    fontSize: 12,
    opacity: 0.8,
    marginBottom: 10,
  },
  broker: {
    fontFamily: 'FordAntenna-Medium',
    textTransform: 'capitalize',
  },
  note: {
    fontSize: 14,
  },
});

interface Props {
  className: string;
  shooting: Shooting;
  onClick: () => void;
}

function ShootingListItem({ className, shooting, onClick }: Props) {
  const intl = useIntl();
  const styles = useStyles();
  const dispatch = useDispatch();

  const { user } = useAuth();

  const isAdmin = user?.role === User.ROLES.ADMIN;
  const cityAddress = shooting.listing?.cityAddress || '';
  const sheduledDate = shooting.scheduleddate || '';

  const fmtID = intl.formatMessage({ id: 'shootings.id' });

  const onOpenShootingDetail = () => {
    dispatch(
      showSideBar({
        type: SIDEBAR.SHOOTING_DETAIL,
        data: { shootingId: shooting.id },
      }),
    );
  };

  return (
    <Paper
      className={classNames(className, styles.shootingListItem)}
      onClick={onOpenShootingDetail}
    >
      {sheduledDate ? (
        <Box>
          <Typography className={styles.date}>
            {moment(sheduledDate).format('YYYY-MM-DD HH:mm A')}
          </Typography>
        </Box>
      ) : null}

      {isAdmin ? (
        <Box>
          <Typography className={styles.broker}>
            {shooting.listing?.broker?.fullName || ''}
          </Typography>
        </Box>
      ) : null}

      {isAdmin ? (
        <Box>
          <Typography>{`${fmtID} : ${shooting.id}`}</Typography>
        </Box>
      ) : null}

      {cityAddress ? (
        <Box>
          <Typography>{cityAddress}</Typography>
        </Box>
      ) : null}

      {!sheduledDate && shooting?.note ? (
        <Box>
          <Typography className={styles.note}>{shooting?.note}</Typography>
        </Box>
      ) : null}
    </Paper>
  );
}

ShootingListItem.defaultProps = {
  className: '',
  onClick: _.noop,
};

ShootingListItem.propTypes = {
  className: PropTypes.string,
  shooting: PropTypes.object.isRequired,
  onClick: PropTypes.func,
};

export default ShootingListItem;
